// label wrapper takes in a recipe, and maps out all the labels based on tag
import React from 'react'

import { useRecipeBrandHook } from '../../model/context/useRecipeBrand'
import {
  Box,
  Display,
  withCitrusTheme,
  Space,
  DisplayPosition,
  Color,
  AlignItems,
  useTheme,
} from '@gousto-internal/citrus-react'
import { Label } from './Label'
import { LabelColorsRecipeTile } from './LabelColors'
import { useRecipe, useStockHook } from '../../model/context'

const LabelWrapperBox = withCitrusTheme(Box, (theme) => ({
  display: Display.Flex,
  borderColor: theme.tokens.colors.White,
  borderWidth: 1.5,
  alignItems: AlignItems.Center,
  position: DisplayPosition.Absolute,
  top: 0,
  left: 0,
  transform: 'translateY(calc(-50% - 1rem))',
  zIndex: 12,
}))

export const LabelWrapper = () => {
  const { theme } = useTheme()
  const useRecipeBrand = useRecipeBrandHook()
  const { useRecipeBrandTag, useRecipeBrandAvailabilityTag } = useRecipeBrand()
  const brandTag = useRecipeBrandTag()
  const recipeTag = useRecipeBrandAvailabilityTag()
  const { id: recipeId, isFineDineIn } = useRecipe()
  const useStock = useStockHook()
  const { isRecipeOutOfStock } = useStock()
  const isOutOfStock = isRecipeOutOfStock(recipeId)

  if (isOutOfStock) {
    const bgColor = isFineDineIn
      ? theme.tokens.colors.ColdGrey_900
      : theme.tokens.colors.ColdGrey_800

    return (
      <LabelWrapperBox>
        <Label text="Sold Out" textColor={Color.White} backgroundColor={bgColor} />
      </LabelWrapperBox>
    )
  }

  //if no tags, return
  if (!brandTag && !recipeTag) {
    return null
  }

  let brandTheme, brandText, recipeTheme, recipeText

  if (brandTag) {
    brandTheme = LabelColorsRecipeTile(brandTag)
    brandText = brandTag.text
  }

  if (recipeTag) {
    recipeTheme = recipeTag.theme
    recipeText = recipeTag.text
  }

  return (
    <LabelWrapperBox>
      {recipeText && recipeTheme && (
        <>
          <Label
            text={recipeText}
            backgroundColor={recipeTheme?.backgroundColor}
            textColor={recipeTheme?.color}
          />
          <Space size={1} direction="horizontal" />
        </>
      )}

      {brandText && brandTheme && (
        <Label
          text={brandText}
          backgroundColor={brandTheme?.backgroundColor}
          textColor={brandTheme?.color}
        />
      )}
    </LabelWrapperBox>
  )
}
